import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { iniciarCapturaDeInstalacion } from './app/shared/utils/install-prompt.store';

// Antes del bootstrap: el navegador dispara `beforeinstallprompt` enseguida y
// si Angular todavía no arrancó, el evento se pierde.
iniciarCapturaDeInstalacion();

if (environment.production) {
  if (window) {
    window.console.log = function () {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
